import {stringISOtoUS} from "../../date-converter";
import {formatName} from "../../utils";

export class FeesPipeline {
    no;
    closeOfEscrow;
    name;
    transactionType;
    city;
    state;
    totalFee;
    listingAgent1;
    listingAgent1Percent;
    listingAgent1Price;
    listingAgent2;
    listingAgent2Percent;
    listingAgent2Price;
    listingAgent3;
    listingAgent3Percent;
    listingAgent3Price;
    buyerAgent1;
    buyerAgent1Percent;
    buyerAgent1Price;
    buyerAgent2;
    buyerAgent2Percent;
    buyerAgent2Price;
    buyerAgent3;
    buyerAgent3Percent;
    buyerAgent3Price;
    striveFee;

    constructor(data, index, total = false) {
        this.no = index || '';
        this.closeOfEscrow = data.CLOSE_OF_ESCROW ? stringISOtoUS(data.CLOSE_OF_ESCROW) : '';
        this.name = data.NAME ? data.NAME : '';
        this.transactionType = data.TRANSACTION_TYPE ? data.TRANSACTION_TYPE : '';
        this.city = data.CITY ? data.CITY : '';
        this.state = data.STATE ? data.STATE : '';
        this.totalFee = data.TOTAL_FEE ? parseFloat(data.TOTAL_FEE) : 0;
        this.listingAgent1 = formatName(data, 'LISTING_AGENT_1_');
        this.listingAgent1Percent = data.LISTING_AGENT_1_PERCENT ? parseFloat(data.LISTING_AGENT_1_PERCENT) : 0;
        this.listingAgent1Price = this.totalFee && this.listingAgent1Percent ? this.totalFee * this.listingAgent1Percent / 100 : 0;
        this.listingAgent2 = formatName(data, 'LISTING_AGENT_2_');
        this.listingAgent2Percent = data.LISTING_AGENT_2_PERCENT ? parseFloat(data.LISTING_AGENT_2_PERCENT) : 0;
        this.listingAgent2Price = this.totalFee && this.listingAgent2Percent ? this.totalFee * this.listingAgent2Percent / 100 : 0;
        this.listingAgent3 = formatName(data, 'LISTING_AGENT_3_');
        this.listingAgent3Percent = data.LISTING_AGENT_3_PERCENT ? parseFloat(data.LISTING_AGENT_3_PERCENT) : 0;
        this.listingAgent3Price = this.totalFee && this.listingAgent3Percent ? this.totalFee * this.listingAgent3Percent / 100 : 0;
        const isOutsideAgent = !parseFloat(data.BUYER_AGENT_1_PERCENT) && parseFloat(data.BUYER_AGENT_4_PERCENT);
        const percentKey = isOutsideAgent ? 'BUYER_AGENT_4_PERCENT' : 'BUYER_AGENT_1_PERCENT';
        this.buyerAgent1 = isOutsideAgent ? 'Outside Agent' : formatName(data, 'BUYER_AGENT_1_');
        this.buyerAgent1Percent = data[percentKey] ? parseFloat(data[percentKey]) : 0;
        this.buyerAgent1Price = this.totalFee && this.buyerAgent1Percent ? this.totalFee * this.buyerAgent1Percent / 100 : 0;
        this.buyerAgent2 = formatName(data, 'BUYER_AGENT_2_');
        this.buyerAgent2Percent = data.BUYER_AGENT_2_PERCENT ? parseFloat(data.BUYER_AGENT_2_PERCENT) : 0;
        this.buyerAgent2Price = this.totalFee && this.buyerAgent2Percent ? this.totalFee * this.buyerAgent2Percent / 100 : 0;
        this.buyerAgent3 = formatName(data, 'BUYER_AGENT_3_');
        this.buyerAgent3Percent = data.BUYER_AGENT_3_PERCENT ? parseFloat(data.BUYER_AGENT_3_PERCENT) : 0;
        this.buyerAgent3Price = this.totalFee && this.buyerAgent3Percent ? this.totalFee * this.buyerAgent3Percent / 100 : 0;
        if (total) this.striveFee = data.STRIVE_FEE;
        else this.striveFee = this.listingAgent1Price + this.listingAgent2Price + this.listingAgent3Price + (!isOutsideAgent ? this.buyerAgent1Price : 0) + this.buyerAgent2Price + this.buyerAgent3Price;
    }
}
